/**
 * @generated SignedSource<<f7a4f50e6bca8a95c291daba59e471ae>>
 * @relayHash 010a839de4f658d76231fa97b8ad759d
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 010a839de4f658d76231fa97b8ad759d

import { ConcreteRequest } from 'relay-runtime';
export type AssociationType = "MANDATORY" | "OPTIONAL";
export type De_generateReferralLetterDocumentInput = {
  allergies: string;
  conditions: string;
  dateOfConsultation: string;
  episodeOfCare: string;
  id: string;
  medications: string;
  patientId: string;
  reasoning: string;
  specialtyName: string;
};
export type useDeGenerateReferralDocumentMutation$variables = {
  input: De_generateReferralLetterDocumentInput;
};
export type useDeGenerateReferralDocumentMutation$data = {
  readonly de_generateReferralLetterDocument: {
    readonly de_ReferralLetter: {
      readonly createdAt: string;
      readonly createdBy: string;
      readonly fileId: string | null;
      readonly icdDiagnosis: {
        readonly associationType: AssociationType | null;
        readonly diagnosisCode: string;
        readonly id: string;
        readonly isAssociation: boolean;
        readonly primaryCode: string | null;
        readonly secondaryCode: string | null;
        readonly text: string;
      };
      readonly id: string;
      readonly patientId: string;
      readonly progressNoteId: string;
      readonly reasoning: string | null;
      readonly signedAt: string | null;
      readonly signedBy: string | null;
      readonly updatedAt: string | null;
      readonly updatedBy: string | null;
    } | null;
  };
};
export type useDeGenerateReferralDocumentMutation = {
  response: useDeGenerateReferralDocumentMutation$data;
  variables: useDeGenerateReferralDocumentMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "De_generateReferralLetterDocumentPayload",
    "kind": "LinkedField",
    "name": "de_generateReferralLetterDocument",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "de_ReferralLetter",
        "kind": "LinkedField",
        "name": "de_ReferralLetter",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "patientId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "progressNoteId",
            "storageKey": null
          },
          (v1/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "fileId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "IcdDiagnosis",
            "kind": "LinkedField",
            "name": "icdDiagnosis",
            "plural": false,
            "selections": [
              (v1/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isAssociation",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "diagnosisCode",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "primaryCode",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "secondaryCode",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "associationType",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "text",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "reasoning",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdBy",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedBy",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "signedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "signedBy",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useDeGenerateReferralDocumentMutation",
    "selections": (v2/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "useDeGenerateReferralDocumentMutation",
    "selections": (v2/*:: as any*/)
  },
  "params": {
    "id": "010a839de4f658d76231fa97b8ad759d",
    "metadata": {},
    "name": "useDeGenerateReferralDocumentMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "81cf31a3a73d8fd98b476fead5d66385";

export default node;
